import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'tree-documentos-entregar',
  template: `
   <div [innerHTML]="html"></div>
  `,
  styles: [`
    .title{
      font-size: 13px;
      background: #7a1217;
      color: #FFFFFF;
      padding: 5px;
      font-weight: bold;
    }
    .lista-documento{
      list-style: none; /* Quitar las viñetas predeterminadas */
      padding: 0;
      margin: 0;
    }
    .lista-documento li{
      position: relative; /* Necesario para posicionar el pseudo-elemento */
      padding-left: 20px; /* Espacio para la viñeta personalizada */
      margin: 10px 0;
    }
    .lista-documento li::before {
      content: '★';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%); /* Centrar verticalmente */
    }
  `]
})
export class TreeDocumentosEntregarComponent implements OnInit {
  @Input() ramas
  html:any='';
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.html= this.sanitizer.bypassSecurityTrustHtml(this.ramas[0].children[0].html);
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/element/tree-documentos-entregar.component.ts